const VoucherReportType = {
  CHART: 1,
  TABLE: 2
}
export default VoucherReportType
